import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Loading from "../../components/Loading";
import SelectPatient from "./SelectPatient";
import UserHome from "./Users/home";
import UserResults from "./Users/UserResults";

const Dashboard = React.lazy(() => import("./Dashboard"));
const RequestList = React.lazy(() => import("./RequestList"));
const RequestForm = React.lazy(() => import("./RequestForm"));
const Appointments = React.lazy(() => import("./Appointments"));
const Patients = React.lazy(() => import("./Patients"));
const Results = React.lazy(() => import("./Results"));
const UserAppointments = React.lazy(() => import("./Users/UserAppointments"));

const AppViews = () => {
  const token = useSelector((state) => state.authSlice.token);
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {token !== null ? (
          <React.Fragment>
            <Route path="/" end element={<RequestList />} />
            <Route path="/request-list" element={<RequestList />} />
            <Route
              path="/select-patient/request-form"
              element={<RequestForm />}
            />
            {/* <Route path="/appointments" element={<Appointments />} /> */}
            <Route path="/patients" element={<Patients />} />
            {/* <Route path="/results" element={<Results />} /> */}
            <Route path="/select-patient" end element={<SelectPatient />} />

            <Route path="*" element={<RequestList />} />
          </React.Fragment>
        ) : (
          <>
            <Route path="/user-home" element={<UserHome />} />
            <Route path="/user-results" element={<UserResults />} />
            <Route path="/user-appointments" element={<UserAppointments />} />

            <Route path="*" element={<UserHome />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};

export default AppViews;
